export default __webpack_public_path__ + "static/media/Pietermaritzburg_North.799611d0.jpg";